import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import palette from '@telus-uds/palette-allium/build/web/palette';

import { Text } from '../css';
import { Box } from '../../design/css';

const OrderComments = ({ data }) => {
  return (
    <>
      {data.map((comment, index) => {
        const { text, createdAt, ...rest } = comment;
        const userName = `${_.get(rest, 'user.first_name', '')} ${_.get(
          rest,
          'user.last_name',
          ''
        )}`;

        const commentDate = moment(createdAt).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        );
        const key = `comment${index}`;

        return (
          text && (
            <Box key={key} top={4}>
              <Text bold color={palette.color.purpleTelus}>
                {userName}
              </Text>
              <Text fontWeight="500">{`${text} - `}</Text>
              <Text bold color={palette.color.greenAccessible}>
                {commentDate}
              </Text>
            </Box>
          )
        );
      })}
    </>
  );
};

OrderComments.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      createdAt: PropTypes.string,
      user: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string
      })
    })
  ).isRequired
};

export default OrderComments;
